// extracted by mini-css-extract-plugin
export default {"GameFeedbackModal":"GameFeedbackModal_GameFeedbackModal__7vcGF","GameFeedbackModal__content":"GameFeedbackModal_GameFeedbackModal__content__Q0xcl"};